export const LAMBDA_METHODTYPE = 1
export const GLUE_METHODTYPE = 2
export const POSTGRES_GLUE_METHODTYPE = 3

export const ZIP_VALUE = 1

export const lookupData = {
	delimiters:
	[
		{
			delimiter: 'Comma ,',
			character: ','
		},
		{
			delimiter: 'Pipe |',
			character: '|'
		},
		{
			delimiter: 'Space',
			character: ' '
		},
		{
			delimiter: 'Semicolon ;',
			character: ';'
		}
	],
	textQualifiers:
	[
		{
			textQualifier: 'Double Quote "',
			character: '"'
		},
		{
			textQualifier: 'none',
			character: ''
		},
		{
			textQualifier: `Single Quote '`,
			character: `'`
		},
		{
			textQualifier: 'Square Brackets [ ]',
			character: '['
		},
		{
			textQualifier: 'Brackets ( )',
			character: '('
		},
		{
			textQualifier: 'Angle Brackets < >',
			character: '<'
		},
		{
			textQualifier: 'Curly Brackets { }',
			character: '{'
		},
		{
			textQualifier: 'Backticks `',
			character: '`'
		}
	],
	rowTerminators: [
		{
			value: 'Newline',
			text: 'Newline (CRLF)'
		},
		{
			value: 'CR only',
			text: 'CR Only'
		}
	],
	cRReplaceTextDefault: '\\r',
	lFReplaceTextDefault: '\\n',
	dateStructures: [
		{ value: 1, text: 'DD/MM/YY' },
		{ value: 2, text: 'DD/MM/YYYY' },
		{ value: 3, text: 'MM/DD/YY' },
		{ value: 4, text: 'MM/DD/YYYY' },
		{ value: 5, text: 'YY/MM/DD' },
		{ value: 6, text: 'YYYY/MM/DD' }
	],
	dateSeparators:
	[
		{
			dateSeparator: '/',
			character: '/'
		},
		{
			dateSeparator: '-',
			character: '-'
		},
		{
			dateSeparator: '.',
			character: '.'
		}
	],
	timeFormats:
	[
		{
			value: true,
			text: '24 Hour'
		},
		{
			value: false,
			text: '12 Hour'
		}
	],
	compressionOptions:
	[
		{
			value: 0,
			text: 'None'
		},
		{
			value: 1,
			text: 'Zip'
		},
		{
			value: 3,
			text: 'Gzip'
		}
	]
}
